// ======================================
// Registration Page Module
// ======================================

import { icons } from '../../components.js';
import { register, isAuthenticated } from '../../lib/auth.js';

export function renderRegisterPage() {
  // Redirect if already logged in
  if (isAuthenticated()) {
    setTimeout(() => {
      window.location.href = '/dashboard';
    }, 0);
    return '<div class="loading">Redirecting...</div>';
  }

  return `
    <section class="auth-section">
      <div class="auth-container">
        <div class="auth-card">
          <div class="auth-header">
            <h1 class="auth-title">Create Account</h1>
            <p class="auth-subtitle">Join NammaVeetuInteriors and start your design journey</p>
          </div>
          
          <form class="auth-form" id="register-form">
            <div class="form-row">
              <div class="form-group">
                <label class="form-label" for="register-name">Full Name *</label>
                <input type="text" id="register-name" name="name" class="form-input" 
                       placeholder="Enter your name" required autocomplete="name">
              </div>
              <div class="form-group">
                <label class="form-label" for="register-phone">Phone Number *</label>
                <input type="tel" id="register-phone" name="phone" class="form-input" 
                       placeholder="+91 82205 95978" required autocomplete="tel">
              </div>
            </div>
            
            <div class="form-group">
              <label class="form-label" for="register-email">Email Address *</label>
              <input type="email" id="register-email" name="email" class="form-input" 
                     placeholder="Enter your email" required autocomplete="email">
            </div>
            
            <div class="form-row">
              <div class="form-group">
                <label class="form-label" for="register-password">Password *</label>
                <div class="password-input-wrapper">
                  <input type="password" id="register-password" name="password" class="form-input" 
                         placeholder="Min 6 characters" required autocomplete="new-password" minlength="6">
                  <button type="button" class="password-toggle" data-target="register-password">
                    ${icons.eye || '<span>👁</span>'}
                  </button>
                </div>
              </div>
              <div class="form-group">
                <label class="form-label" for="register-confirm">Confirm Password *</label>
                <input type="password" id="register-confirm" name="confirm_password" class="form-input" 
                       placeholder="Repeat password" required autocomplete="new-password">
              </div>
            </div>
            
            <div class="form-group">
              <label class="checkbox-label">
                <input type="checkbox" name="terms" class="form-checkbox" required>
                <span>I agree to the <a href="/terms" class="auth-link">Terms of Service</a> and <a href="/privacy" class="auth-link">Privacy Policy</a></span>
              </label>
            </div>
            
            <div id="register-error" class="auth-error" style="display: none;"></div>
            
            <button type="submit" class="btn btn-primary btn-lg btn-block" id="register-btn">
              Create Account
            </button>
          </form>
          
          <div class="auth-footer">
            <p>Already have an account? <a href="/login" class="auth-link">Sign in</a></p>
          </div>
        </div>
        
        <div class="auth-aside">
          <div class="auth-aside-content">
            <h2>Why Create an Account?</h2>
            <ul class="auth-benefits">
              <li>${icons.check || '✓'} Save your design preferences</li>
              <li>${icons.check || '✓'} Get personalized recommendations</li>
              <li>${icons.check || '✓'} Track project milestones</li>
              <li>${icons.check || '✓'} Access exclusive offers</li>
              <li>${icons.check || '✓'} Manage payments easily</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  `;
}

export function initRegisterPage() {
  const form = document.getElementById('register-form');
  const errorDiv = document.getElementById('register-error');
  const submitBtn = document.getElementById('register-btn');

  if (!form) return;

  // Password toggle
  const toggleBtn = form.querySelector('.password-toggle');
  if (toggleBtn) {
    toggleBtn.addEventListener('click', () => {
      const targetId = toggleBtn.dataset.target;
      const input = document.getElementById(targetId);
      if (input) {
        input.type = input.type === 'password' ? 'text' : 'password';
      }
    });
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const name = form.name.value.trim();
    const phone = form.phone.value.trim();
    const email = form.email.value.trim();
    const password = form.password.value;
    const confirmPassword = form.confirm_password.value;

    // Validation
    if (!name || !phone || !email || !password) {
      showError('Please fill in all required fields');
      return;
    }

    if (password !== confirmPassword) {
      showError('Passwords do not match');
      return;
    }

    if (password.length < 6) {
      showError('Password must be at least 6 characters');
      return;
    }

    // Phone validation (Indian format)
    const phoneClean = phone.replace(/\s+/g, '');
    if (!/^[\+]?[0-9]{10,13}$/.test(phoneClean)) {
      showError('Please enter a valid phone number');
      return;
    }

    // Disable button and show loading
    submitBtn.disabled = true;
    submitBtn.innerHTML = '<span class="spinner"></span> Creating account...';
    errorDiv.style.display = 'none';

    try {
      await register({ name, phone, email, password });

      // Redirect to dashboard
      window.location.href = '/dashboard';
    } catch (error) {
      showError(error.message || 'Registration failed. Please try again.');
      submitBtn.disabled = false;
      submitBtn.innerHTML = 'Create Account';
    }
  });

  function showError(message) {
    errorDiv.textContent = message;
    errorDiv.style.display = 'block';
  }
}
